import { render, staticRenderFns } from "./_TableAction.vue?vue&type=template&id=3328be4a&scoped=true&"
import script from "./_TableAction.vue?vue&type=script&lang=js&"
export * from "./_TableAction.vue?vue&type=script&lang=js&"
import style0 from "./_TableAction.vue?vue&type=style&index=0&id=3328be4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3328be4a",
  null
  
)

export default component.exports